<template>
<div class="chapter">
<div class="inner_page">
<p class="stitle1"><a id="page_iii">The House by the Sea</a></p><a id="page_iii">
<p class="stitle1a">Previously published as The Mermaid Garden</p>
<p class="stitle2">Santa Montefiore</p>
<p class="stitle3">Simon &amp; Schuster Paperbacks</p>
<p class="stitle4">New York London Toronto Sydney New Delhi</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?50dbacee